export default __webpack_public_path__ + "static/media/question.46421a6c.svg";